import React from "react";
import { useLanguage } from "../utils/LanguageContext";
import en from "../utils/languages/en.jsx";
import fr from "../utils/languages/fr.jsx";
const About = ({ theme }) => {
  const { language } = useLanguage();
  const translations = {
    en,
    fr,
  };

  const currentTranslations = translations[language];
  return (
    <section
      className="flex flex-row h-[25rem] xxxs:h-auto xxxs:flex-col-reverse xxs:h-auto xxs:flex-col-reverse xs:h-auto xs:flex-col-reverse justify-between xxxs:mx-auto xxxs:pl-1 xxs:mx-auto xxs:pl-1 xs:mx-auto sm:mx-auto xs:pl-1 sm:justify-between sm:items-center"
      id="about"
    >
      <div className="sm:w-2/3">
        <h2 className={`${theme === "dark" ? "title-dark" : "title"}`}>
          {currentTranslations.titleAbout}
        </h2>
        <p className="text-white dark:text-gray-600 my-4 text-lg md:text-2xl lg:text-xl">
          {language === "en"
            ? "Hello, I'm here to"
            : "Bonjour, je suis là pour"}{" "}
          <br />
          {language === "en"
            ? "assist you with your next project."
            : "vous aider pour votre prochain projet."}
        </p>
        <p className="text-lg pb-14 text-gray-400 max-w-2xl dark:text-gray-600 md:text-xl lg:text-xl">
          {currentTranslations.infoAbout}
        </p>
        <div className="flex justify-start">
          <a
            href={`
            ${
              language === "en"
                ? "https://res.cloudinary.com/ujuzi/image/upload/v1690534701/mes_nouveaux_cv_2023/MWAFRIKA_CV_english_psv9lv.pdf"
                : "https://res.cloudinary.com/ujuzi/image/upload/v1690534701/mes_nouveaux_cv_2023/MWAFRIKA_CV_french_ais0yp.pdf"
            }`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <button
              className="bg-gradient-to-r from-violet-500 to-sky-500 px-10 xxxs:text-xl xxxs:px-5 xxs:text-xl xxs:px-5 xs:text-xl sm:text-xl xs:px-5 sm:px-5 py-2 rounded-[50px] shadow-lg hover:shadow-xl hover:bg-gray-600 hover:text-white
          transition-all duration-200 ease hover:bg-gradient-to-l 
          "
            >
              {language === "en" ? "View CV" : "Voir le CV"}
            </button>
          </a>
        </div>
      </div>
      <div className="flex items-center">
        <img
          src={currentTranslations.imageAbout}
          alt=""
          className="rounded-full w-64 h-64 xxxs:w-28 xxxs:h-28 xxs:w-28 xxs:h-28 xs:w-28 xs:h-28 sm:w-32 sm:h-32 md:w-44 md:h-44"
        />
      </div>
    </section>
  );
};

export default About;
